<template>
  <section class="wizard">
    <Header />
    <component
      :is="sectorFromState.inAppStep"
      @goToLocation="goToLocation"
      @goToInsulation="goToInsulation"
      @goToBase="goToBase"
      @goToDampCourse="goToDampCourse"
      @goToSector="goToSector"
      @goToMinorResult="goToMinorResult"
      @addFromNav="addSector"
      @addSector="addSector"
      @showDeleteConfirmation="showDeleteConfirmation"
      ref="Steps">
    </component>
    <transition name="fading">
      <DeleteConfirmation v-if="isShowDeleteConfirmation"
                          @confirm="deleteSector"
                          @cancel="isShowDeleteConfirmation = !isShowDeleteConfirmation"/>
    </transition>
  </section>
</template>
<script>

import { mapMutations, mapState } from 'vuex';
import Base from '@/components/Base.vue';
import Insulation from '@/components/Insulation.vue';
import DampCourse from '@/components/DampCourse.vue';
import MinorResult from '@/components/MinorResult.vue';
import Sector from '@/components/Sector.vue';
import Header from '@/components/Header.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';

export default {
  data() {
    return {
      isShowDeleteConfirmation: false,
    };
  },
  components: {
    Base,
    Insulation,
    DampCourse,
    MinorResult,
    Sector,
    Header,
    DeleteConfirmation,
  },
  methods: {
    ...mapMutations({
      ADD_NEW_SECTOR: 'ADD_NEW_SECTOR',
      UPDATE_SECTOR_STEP: 'UPDATE_SECTOR_STEP',
      DELETE_SECTOR: 'DELETE_SECTOR',
    }),
    scrollTop() {
      window.scrollTo(0, 0);
    },
    goToLocation() {
      this.$router.push('/location');
    },
    goToBase() {
      this.UPDATE_SECTOR_STEP({
        id: this.sectorId,
        val: 'Base',
      });
      this.scrollTop();
    },
    goToInsulation() {
      this.UPDATE_SECTOR_STEP({
        id: this.sectorId,
        val: 'Insulation',
      });
      this.scrollTop();
    },
    goToDampCourse() {
      this.UPDATE_SECTOR_STEP({
        id: this.sectorId,
        val: 'DampCourse',
      });
      this.scrollTop();
    },
    goToSector() {
      this.UPDATE_SECTOR_STEP({
        id: this.sectorId,
        val: 'Sector',
      });
      this.scrollTop();
    },
    goToMinorResult() {
      this.UPDATE_SECTOR_STEP({
        id: this.sectorId,
        val: 'MinorResult',
      });
      this.scrollTop();
    },
    addSector() {
      this.ADD_NEW_SECTOR();
      this.$router.push(`/wizard/${this.sectors.length - 1}`);
      this.scrollTop();
      setTimeout(() => this.$refs.Steps.$refs.Nav.$refs.mySwiper.swiper.slideTo(
        this.sectors.length, 1000,
      ), 0);
    },
    showDeleteConfirmation() {
      this.isShowDeleteConfirmation = true;
      this.$root.offBodyScroll();
    },
    deleteSector() {
      if ((this.sectors.length - 1) === parseInt(this.sectorId, 10)) {
        this.DELETE_SECTOR(this.sectorId);
        this.$router.push(`/wizard/${this.sectorId - 1}`);
        this.$root.onBodyScroll();
      } else {
        this.DELETE_SECTOR(this.sectorId);
        this.$root.onBodyScroll();
      }
    },
  },
  watch: {
    isShowDeleteConfirmation() {
      // eslint-disable-next-line
      this.isShowDeleteConfirmation === true ? this.$root.offBodyScroll() :
        this.$root.onBodyScroll();
    },
  },
  mounted() {
    // if (this.sectorFromState.material.id) {
    //   this.step = 'Sector';
    // } else {
    //   this.step = 'Base';
    // }
    if (this.location.zone === '') {
      this.$router.push('/');
      console.clear();
    }
  },
  computed: {
    ...mapState({
      sectors: state => state.sectors,
      location: state => state.location,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
  },
};
</script>
<style lang="sass" scoped>
  .fading-enter-active, .fading-leave-active
    transition: opacity .5s

  .fading-enter, .fading-leave-to
    opacity: 0
</style>
